;(function () {
  'use strict'
  angular.module('obex').factory('socketEvent', [
    '$rootScope',
    'socket',
    'socketLogin',
    'alertService',
    function ($rootScope, socket, socketLogin, alertService) {
      var _socketId = null
      var _timeConnected = null
      socket.on('my socketId', function (data) {
        console.log(
          'socket id, time connected ',
          data.socketId,
          data.timeConnected,
        )
        socketLogin.setSocketIdAndSend(data.socketId)
      })

      socket.on('unhandledIncomingText', function (data) {
        console.log('unhandledIncomingText', data)
        $rootScope.$broadcast('updateAlerts', data)
        $rootScope.$broadcast('updateAlertCount', data)
        $rootScope.$broadcast('notifyDesktop', data)
      })

      socket.on('incomingText', function (data) {
        console.log('incomingText', data)
        $rootScope.$broadcast('incomingText', data)
      })

      socket.on('outgoingText', function (data) {
        console.log('outgoingText', data)
        $rootScope.$broadcast('outgoingText', data)
      })

      socket.on('updateAlertCount', function () {
        console.log('updateAlertCount')
        $rootScope.$broadcast('updateAlerts')
        $rootScope.$broadcast('updateAlertCount')
      })

      socket.on('unhandledIncomingVoice', function (data) {
        console.log('unhandledIncomingVoice', data)
        $rootScope.$broadcast('updateAlertsVoice', data)
        $rootScope.$broadcast('updateAlertCountVoice', data)
      })

      socket.on('updateAlertCountVoice', function () {
        console.log('updateAlertCountVoice')
        //\\$rootScope.$broadcast('updateAlerts');
        $rootScope.$broadcast('updateAlertCountVoice')
      })

      return {}
    },
  ])
})()



// WEBPACK FOOTER //
// ./client/js/services/socketEvent.service.js